export const updateNav = (state, action) => {
    state.leaderboard.nav = {
        ...state.leaderboard.nav,
        [action.payload.name]: action.payload.value
    };
};
